// ── Email helper ───────────────────────────────────────────────
const EMAIL_ADDRESS = `${"info"}@${"dawnedinstruments.com"}`;
const EMAIL_HREF = `mailto:${EMAIL_ADDRESS}`;
export { EMAIL_ADDRESS, EMAIL_HREF };

// ── Brand ──────────────────────────────────────────────────────
export const brand = {
  name: "Dawned Instruments",
};

// ── Various / Common UI ────────────────────────────────────────
export const various = {
  noItems: "No items in cart",
  loading: "Loading...",
  loadingVideo: "Loading video...",
  close: "Close",
  shoppingCart: "Shopping Cart",
  cart: "Cart",
  checkout: "CHECKOUT",
  buyIt: "BUY IT!",
  quantityLabel: "Quantity",
  outOfStockButton: "OUT OF STOCK",
  selectProduct: "Welcome! Select a product to view details",
  paypalCheckout: "PayPal checkout",
  processingPayment: "Processing your payment, please wait...",
  pdfManual: "User Manual",
  features: "Features",
  specifications: "Specifications",
  noDetailsAvailable: "No details available for this product",
  noDetailsShort: "No details available",
  firmwareUpdates: "Firmware Updates",
  settingsEditor: "Settings Editor",
  settingsEditorMobileNote: "The Settings Editor is available only on desktop. Please visit this page from a computer.",
  noImageAvailable: "No image available",
  noVideosAvailable: "No video available",
  unsupportedBrowser: "Unsupported browser",
  safariTooltip: "The editor is compatible only on Chrome and Firefox browsers",
  productTabs: ["Overview", "Photos", "Videos", "Details"],
  midiGrantError1:
    "Permission to use the Web MIDI API was not granted. Please allow MIDI access and refresh the page before using the editor.",
  midiGrantError2:
    "Unable to access MIDI devices. Please allow MIDI access and refresh the page before using the editor.",
};

// ── Settings Editor ───────────────────────────────────────────
export const settingsEditor = {
  title: "Settings Editor",
  disclaimer:
    "Before using the editor, please make sure {device} is updated to the latest firmware version available on the {link}.",
  disclaimerLinkText: "firmware updates page",
  notConnected: "not connected!",
  notConnectedHelp: "Please connect {device} to your computer using a USB cable, and {link}",
  notConnectedHelpLinkText: "refresh this page",
  connected: "connected!",
  connectedHelp:
    "Configure the settings and click 'Save to {device}' when ready! Do not disconnect {device} from your computer during the process.",
  connectedHelp2: "You can back up your settings to a file and load them from your computer",
  buttonLoadDevice: "Load from {device}",
  buttonLoading: "LOADING...",
  buttonSaveDevice: "Save to {device}",
  buttonLoadFile: "Load from file",
  buttonSaveFile: "Save to file",
  buttonForceResync: "Force resync",
  buttonCalibrate: "Calibrate",
  calibrateConfirm:
    "Start VCO calibration on {device}? The synth will be silent for about a minute and cannot be played until it finishes. Hold FN on the unit for 2s to abort.",
  firmwareLabel: "Current Firmware version:",
  noResponseError:
    "No response from device. Make sure the device is connected, and the browser has the permissions to communicate with the device",
  devBadge: "DEV MODE",
  featureLockedTooltip: "will be available on the next firmware update",
  syncing: "Syncing with {device}…",
  syncConnect: "Connect {device} to use the editor",
  calibrating: "Calibrating {device}… hold FN on the unit for 2s to abort",
};

// ── Firmware Updates ──────────────────────────────────────────
export const firmwareUpdates = {
  title: "{device} Firmware Updates",
  currentVersion: "Current firmware version:",
  releaseDate: "Release date:",
  noUpdateNeeded: "If you purchased {device} after this date, you don't need to update.",
  futureUpdates: "Any future firmware updates will be published here.",
  downloadButton: "Download Firmware v{version}",
  howToUpdate: "How to Update",
  settingsNoteBefore:
    "Any settings stored on {device} will be erased by the update, so you'll need to configure them again unless you create a backup in the",
  settingsEditorLinkText: "Settings Editor",
  settingsNoteNoLink:
    "Any settings stored on {device} will be erased by the update, so you'll need to configure them again unless you create a backup in the Settings Editor",
};

// ── Navigation ─────────────────────────────────────────────────
export const navigation = {
  about: "About",
  products: "Products",
};

// ── Alerts ─────────────────────────────────────────────────────
export const alerts = {
  invalidEmail: "Please enter a valid email address.",
  subscribeSuccess: "Thank you for subscribing!",
  subscribeFailed: "Subscription failed. Please try again.",
  subscribeError: "An error occurred. Please try again.",
  joinWaitingListMessage: "Thank you for joining our waiting list!",
};

// ── Success Page ───────────────────────────────────────────────
export const successPage = {
  title: "Thank you for your purchase!",
  message: "A confirmation email has been sent to your email address.",
  orderSummary: "Order Summary",
  shippingDetails: "Shipping Details",
  orderReference: "Order Reference",
  orderDate: "Order Date",
  orderNotFound: "No order details found.",
};

// ── About / Team ───────────────────────────────────────────────
export const about = {
  teamTitle: "The Team",
  teamBio:
    "Dawned Instruments is a small team based in Italy, founded by Dimitri Petrucci in 2024. " +
    "Dimitri is a musician and computer engineer with a lifelong passion for musical instruments. " +
    "He began building electronic circuits and electric guitars while in high school, and started " +
    "designing his own analog/digital synthesizers in 2013. He graduated with a degree in Computer " +
    "Engineering in 2017, with a thesis focused on building an electronic keyboard with touch sensors.",
  newsletterTitle: "Newsletter",
  newsletterDescription:
    "Sign up for our newsletter to receive the latest news, exclusive offers, and updates on new products",
  newsletterPlaceholder: "Your email",
  newsletterButton: "Subscribe",
  newsletterDisclaimer: "You can unsubscribe anytime. For more details, review our",
  newsletterDisclaimerLinkText: "Privacy Policy",
};

// ── Out of Stock ───────────────────────────────────────────────
export const outOfStock = {
  title: productName => `We're sorry, ${productName} is currently out of stock`,
  subtitle: "Join our waiting list to be notified when it becomes available again!",
  placeholder: "Your email",
  button: "Notify me!",
  note: "We respect your privacy and will only use your email to notify you about restocks.",
};

// ── Unsubscribe ───────────────────────────────────────────────
export const unsubscribe = {
  loadingTitle: "Unsubscribing...",
  errorTitle: "Unsubscribe failed",
  errorMessage: "Something went wrong. Please try again or contact us at",
  invalidTitle: "Invalid link",
  invalidMessage: "This unsubscribe link is not valid.",
  confirmButton: "Confirm Unsubscription",
  newsletter: {
    confirmTitle: "Unsubscribe from our newsletter",
    confirmMessage: "Click the button below to confirm you want to stop receiving our newsletter.",
    successTitle: "Unsubscribed",
    successMessage: "You have been successfully removed from our newsletter.",
    notFoundTitle: "Not found",
    notFoundMessage: "This email address is not subscribed to our newsletter.",
  },
  waitinglist: {
    confirmTitle: productName => `Unsubscribe from ${productName} waiting list`,
    confirmMessage: productName =>
      `Click the button below to confirm you want to be removed from the waiting list for ${productName}.`,
    successTitle: "Unsubscribed",
    successMessage: productName => `You have been removed from the waiting list for ${productName}.`,
    notFoundTitle: "Not found",
    notFoundMessage: productName => `This email address is not on the waiting list for ${productName}.`,
  },
};

// ── Maintenance ───────────────────────────────────────────────
export const maintenance = {
  title: "We will be back soon",
  message: "Our website is currently undergoing scheduled maintenance.",
  patience: "We apologize for the inconvenience and appreciate your patience.",
  contact: "In the meantime, feel free to reach us at",
};

// ── Cookie Consent ─────────────────────────────────────────────
export const cookie = {
  message:
    "We use technical and session cookies to improve your shopping experience. " +
    "By clicking 'Accept,' you consent to the use of cookies.",
  accept: "Accept",
  reject: "Reject",
};

// ── Footer ─────────────────────────────────────────────────────
export const footer = {
  contactsTitle: "Contacts",
  emailLinkText: "email",
  legalsTitle: "Legals",
  privacyPolicyLink: "Privacy Policy",
  termsConditionsLink: "Terms & Conditions",
  linksTitle: "Links",
};

// ── Checkout ──────────────────────────────────────────────────
export const checkout = {
  billingShippingTitle: "Billing & Shipping",
  yourOrderTitle: "Your Order",
  shippingCostsLabel: "Shipping costs:",
  totalLabel: "Total:",
  totalPlusShipping: "+ Shipping costs",
  cartEmptyMessage: "Your cart is empty. Please add products to proceed with the checkout.",
  selectCountryWarning: "Select the country to get shipping rates",
  paymentFailed: "Payment failed",
  missingData: "Missing data",
  errorDuringPayment: "Error during payment",
  errorDuringPaymentIT: "Si è verificato un errore durante il pagamento, riprovare.",
  closeButton: "Close",
  usuallyAvailable: "Usually available for shipping in 3-5 days",
  shippingInfos:
    "Shipping is handled from Italy. Outside the EU, duties and taxes may apply, for which we are not responsible. For further details, please read our",
  termsConditionsMessageLink: "Terms & Conditions",
  usaWarningTitle: "For customers in the USA:",
  usaWarning:
    " duties and taxes are included in the shipping price and paid in advance, in accordance with recent USA customs regulations. ",
  usaMoreInfo: "More infos -> here",
  usaTaxesLink: "https://www.poste.it/servizio-gestione-dazi",
  // Form labels
  firstNameLabel: "First name *",
  lastNameLabel: "Last name *",
  emailLabel: "Email address *",
  addressLine1Label: "Address line 1 *",
  addressLine2Label: "Address line 2 (optional)",
  cityLabel: "City *",
  zipCodeLabel: "ZIP / Postal Code *",
  countryLabel: "Country *",
  phoneLabel: "Phone *",
  selectCountryOption: "Select a country",
  fillFormWarning: "Please fill in all required fields before proceeding to payment.",
  termsCheckboxText: "I have read and accept the ",
  termsCheckboxLink: "Terms & Conditions",
};

// ── Privacy Policy ─────────────────────────────────────────────
export const privacyPolicy = {
  title: "Privacy Policy",
  intro:
    "Thank you for choosing Dawned Instruments. Protecting your privacy is important to us. " +
    "This Privacy Policy explains how we collect, use, and protect your personal data in compliance " +
    "with global regulations, including the General Data Protection Regulation (GDPR) and the " +
    "California Consumer Privacy Act (CCPA).",
  sections: [
    {
      heading: "1. Information We Collect",
      content: [
        { type: "p", text: "We collect the following types of personal data when you place an order on our website:" },
        {
          type: "list",
          intro: "Personal Information:",
          items: ["Name and Surname", "Email Address", "Residential Address (for shipping purposes)", "Phone Number"],
        },
        { type: "p", text: "We do not collect any non-personal data or use cookies." },
      ],
    },
    {
      heading: "2. How We Use Your Information",
      content: [
        { type: "p", text: "Your personal data is used exclusively to:" },
        {
          type: "bullets",
          items: ["Process and fulfill your order.", "Ship purchased items to your provided address."],
        },
        {
          type: "p",
          text: "We do not use your data for marketing or any purposes unrelated to the processing of your orders.",
        },
      ],
    },
    {
      heading: "3. Data Sharing",
      content: [
        { type: "p", text: "We do not share, sell, or disclose your personal data to any third parties, except:" },
        {
          type: "bullets",
          items: [
            {
              bold: "PayPal:",
              text: " For secure payment processing. Your payment details are handled directly by PayPal under their privacy terms.",
            },
            {
              bold: "Firebase:",
              text: " Your data is stored temporarily in a Firebase database, which adheres to strict security standards.",
            },
          ],
        },
      ],
    },
    {
      heading: "4. Data Retention",
      content: [
        {
          type: "p",
          text: "We retain your personal data for 30 days after your order has been completed. After this period, your data is permanently deleted from our systems.",
        },
      ],
    },
    {
      heading: "5. Your Rights",
      content: [
        { type: "bold-intro", text: "For Users in the European Union (GDPR):" },
        { type: "p", text: "You have the following rights:" },
        {
          type: "bullets",
          items: [
            { bold: "Access:", text: " Request a copy of your personal data." },
            { bold: "Correction:", text: " Request corrections to inaccurate or incomplete data." },
            { bold: "Erasure:", text: " Request deletion of your data." },
            { bold: "Restriction:", text: " Limit the processing of your data." },
            { bold: "Portability:", text: " Request a transfer of your data to another service." },
            { bold: "Objection:", text: " Object to the processing of your data in certain circumstances." },
          ],
        },
        { type: "contact-link", text: "To exercise these rights, " },
        { type: "bold-intro", text: "For Users in California (CCPA):" },
        { type: "p", text: "You have the right to:" },
        {
          type: "bullets",
          items: [
            "Know what personal data we collect and why.",
            "Request deletion of your personal data.",
            "Opt-out of the sale of your data (note: we do not sell data).",
          ],
        },
        { type: "contact-link", text: "To submit a request, " },
      ],
    },
    {
      heading: "6. Data Security",
      content: [
        {
          type: "p",
          text: "We implement robust security measures to protect your personal data from unauthorized access, alteration, disclosure, or destruction. These include:",
        },
        {
          type: "bullets",
          items: ["Encrypted storage of data in Firebase.", "Secure data transmission protocols."],
        },
      ],
    },
    {
      heading: "7. Payment Processing",
      content: [
        {
          type: "p",
          text: "All payments on our site are processed through PayPal, which adheres to PCI-DSS standards for secure transactions. We do not store or access your payment information.",
        },
      ],
    },
    {
      heading: "8. International Data Transfers",
      content: [
        {
          type: "p",
          text: "As an Italy-based company, your data is stored and processed in compliance with the GDPR. For international users, we ensure equivalent protection measures.",
        },
      ],
    },
    {
      heading: "9. Changes to This Privacy Policy",
      content: [
        {
          type: "p",
          text: "We reserve the right to update this Privacy Policy as necessary to reflect changes in our practices or regulatory requirements. Any changes will be posted on this page with an updated effective date.",
        },
      ],
    },
    {
      heading: "10. Contact Us",
      content: [
        {
          type: "contact-link",
          text: "If you have questions or requests regarding this Privacy Policy, please contact us at our ",
          linkText: "email address",
        },
        {
          type: "p",
          text: "This Privacy Policy complies with the GDPR, CCPA, and other relevant regulations. By using our site, you agree to the terms of this policy.",
        },
      ],
    },
  ],
};

// ── Terms & Conditions ─────────────────────────────────────────
export const termsConditions = {
  title: "Terms & Conditions",
  intro:
    "By placing an order using this website, you agree to comply with and be bound by the following " +
    "Terms and Conditions. Please read them carefully before placing an order. These terms apply to " +
    "all users of this website, including customers, browsers, and merchants.",
  sections: [
    {
      heading: "Product Information",
      content: [
        {
          type: "p",
          text: "Each product we offer is described in detail, including model, features, and availability. Prices are listed in Euro and are subject to change without notice. Product images are for reference only. Actual products may vary slightly due to lighting, color differences, or manufacturing variations.",
        },
      ],
    },
    {
      heading: "Prices And Payment",
      content: [
        {
          type: "p",
          text: "All prices are listed in Euro and the final price will be confirmed at checkout. Prices may vary due to promotions, currency fluctuations, or changes in suppliers. We accept payments through PayPal. By selecting PayPal as a payment option, you agree to PayPal's terms and conditions. Payments are processed immediately upon checkout.",
        },
      ],
    },
    {
      heading: "Shipping",
      content: [
        {
          type: "p",
          text: "Currently, we ship all orders from Italy within 5 working days (if the item is available). We ship worldwide, to the address you provide during the ordering process, and the shipping costs are calculated during the checkout. We offer a tracking number to all of our shipments.",
        },
        {
          type: "p",
          text: "Our shipping estimates do not include the time used for Customs procedures in the country of destination. That means that sometimes it may take longer (or shorter) depending on where you live. Some orders may experience customs delays if your country is not part of the EU because your order may be subject to import duties, customs tariffs, or VAT charges. For orders shipped to countries outside the European Union, we are not responsible for the cost of any specific taxes payable in the destination country. These are in addition to, and not included in, the shipping cost and are incurred at the time of delivery. Customers are responsible for all international customs and duty fees.",
        },
      ],
    },
    {
      heading: "International Shipping (Outside the EU)",
      content: [
        {
          type: "p",
          text: "For orders shipped to countries outside the European Union, we are not responsible for the cost of any specific taxes payable in the destination country. These are in addition to, and not included in, the shipping cost and are incurred at the time of delivery. Customers are responsible for all international customs and duty fees.",
        },
        {
          type: "p",
          text: 'We are not able to mark items as "gifts" as it is illegal. The amount of these taxes or duties will vary depending on each country\'s import/export laws, and it is your responsibility to be informed of them and of all formalities required to deliver the order. You should inquire with your local customs agency for more information and assistance in this area.',
        },
        {
          type: "p",
          text: "For shipments to countries outside the European Union, please remember that shipping costs do not include customs duties, which must be paid by the recipient when the parcel is delivered.",
        },
      ],
    },
    {
      heading: "Warranty",
      content: [
        {
          type: "p",
          text: "All our products are covered by the standard 2-year EU warranty on purchased goods which begins when you receive your goods.",
        },
      ],
    },
    {
      heading: "Ordering Process",
      content: [
        {
          type: "p",
          text: "Once an order has been placed and payment has been confirmed, it cannot be cancelled or modified. This is because our fulfilment process — including packaging and shipment preparation — begins automatically and immediately upon receipt of payment.",
        },
        {
          type: "p",
          text: "If you change your mind after placing an order, you will need to wait until the product has been delivered and then exercise your right of withdrawal in accordance with the Returns And Exchanges policy outlined below.",
        },
      ],
    },
    {
      heading: "Returns And Exchanges",
      content: [
        {
          type: "p",
          text: "Upon receipt of your order, you have 14 days to change and/or return any products. The products and their packaging must be in perfect condition. If you have not contacted us before returning the goods and have not waited to receive the authorization number for the return, we reserve the right to accept the return.",
        },
        {
          type: "p",
          text: "Once the return is approved (the items have to be in perfect condition) you will receive a confirmation email telling you that the amount will be credited to your Paypal account. For returns, shipping costs are the customer’s responsibility.",
        },
        {
          type: "p",
          text: "If the returned product is inspected and no defects or issues are found with the unit, only the product price will be refunded. Shipping costs will not be refunded.",
        },
        {
          type: "p",
          text: "We reserve the right to refuse returns that have been communicated or sent after the deadline, or products that are not in the same condition in which they were received.",
        },
        {
          type: "p",
          text: "We are not responsible for any damages, losses, or other liabilities resulting from the use or misuse of the products purchased from our store. This includes any direct or indirect damages to property, personal injury, or economic losses. The products should be used only as described and intended. Customers assume all risks associated with the use of the products.",
        },
      ],
    },
    {
      heading: "Replacement",
      content: [
        {
          type: "p",
          text: "If the product supplied is incorrect or defective, it will be replaced by another item of the same model, or the same item repaired. The delivery time depends on the availability of the new product or its repair. You will be informed immediately of the status of the claim and you can decide whether to ask for a refund or to wait for the new product.",
        },
      ],
    },
    {
      heading: "Contact",
      content: [
        {
          type: "contact-link",
          text: "For all general inquiries, privacy policy, terms and conditions, legal notes, copyright, and sale conditions inquiries: ",
        },
      ],
    },
  ],
};
